// extracted by mini-css-extract-plugin
export default {"tooltip":"MT-z","arrow":"NT-z"};